import React from 'react';

const Sidemenu = ({ isOpen, side, children }) => (
  <div className={`sidemenu ${isOpen && 'is-open'} ${side && `is-${side}`}`}>
    <div className="sidemenu__container">{children}</div>
  </div>
);

export default Sidemenu;
